/* eslint-disable @typescript-eslint/ban-types */
import { useEffect, useState } from 'react';
import { SearchEngine, loadPaginationActions, loadQueryActions } from '@coveo/headless';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-nextjs/utils';

const useStandaloneSearchData = (engine: SearchEngine<{}>): string => {
  const [standaloneData, setStandaloneData] = useState('');
  const { updateQuery } = loadQueryActions(engine);
  const { updatePage } = loadPaginationActions(engine);
  const { sitecoreContext } = useSitecoreContext();

  useEffect(() => {
    if (isEditorActive() || sitecoreContext?.pageState === 'preview') {
      return;
    }
    if (typeof window !== 'undefined') {
      const data = localStorage.getItem('coveo_standalone_search_box_data');

      if (!data) {
        updatePage(1);
        engine.executeFirstSearch();
      } else {
        localStorage.removeItem('coveo_standalone_search_box_data');
        const { value, analytics } = JSON.parse(data || '{}');
        setStandaloneData(value);
        engine.dispatch(updateQuery({ q: value }));
        updatePage(1);
        engine.executeFirstSearchAfterStandaloneSearchBoxRedirect(analytics);
      }
    }
  }, [engine, updateQuery]);

  return standaloneData;
};

export default useStandaloneSearchData;
